export const shippingFulfillmentValues = {
  update: 'update',
  noUpdate: 'noUpdate',
}

export const shippingFulfillmentOptions = [
  {
    value: shippingFulfillmentValues.update,
    label: 'Actualizar el estado de envío en la plataforma de comercio electrónico',
  },
  {
    value: shippingFulfillmentValues.noUpdate,
    label: 'No actualizar el estado de envío',
  },
]
